import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../core/services/api/auth.service';

/**
 * Empêche l'accès aux routes protégées si l'utilisateur n'a pas de JWT valide.
 * Sur échec : redirige vers `/login?returnUrl=<route demandée>`.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });
};
